import axios, { AxiosRequestConfig } from 'axios'
import store from '@/store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { restHeartOrigin } from './config'
import Vue from 'vue'
import { Message } from 'element-ui'

const restHeartClient = axios.create({
	headers: {
		'Content-Type': 'application/json',
	},
})

/**
 *
 * @param error
 */
function err(error) {
	if (error.response) {
		const data = error.response.data
		const token = Vue.ls.get(ACCESS_TOKEN)
		console.log('------异常响应------', token, error.response.status)
		switch (error.response.status) {
			case 403:
				Message.error({ showClose: true, message: '拒绝访问', type: 'warning' })
				break
			case 404:
				Message.error({ showClose: true, message: '资源未找到,404', type: 'warning' })
				break
			case 504:
				Message.error({ showClose: true, message: '网络超时', type: 'warning' })
				break
			case 401:
				console.log('注销', token)
				if (token) {
					store.dispatch('Logout').then(() => {
						setTimeout(() => {
							window.location.reload()
						}, 1500)
					})
				}
				break
			default:
				Message.error(data.message)
				break
		}
	}

	return Promise.reject(error)
}

/**
 * request interceptor
 */
restHeartClient.interceptors.request.use(
	function(this: any, config: AxiosRequestConfig) {
		const token = Vue.ls.get(ACCESS_TOKEN)
		if (token) {
			config.headers['X-Access-Token'] = token
		}

		return config
	},
	error => {
		return Promise.reject(error)
	}
)

/**
 * response interceptor
 */
restHeartClient.interceptors.response.use(response => {
	return response
}, err)

// 开发时由本地代理服务器转发到 restHeartOrigin，代理服务器会将 devServer 删掉，并且替换为 restHeartOrigin 的值。
restHeartClient.defaults.baseURL = process.env.NODE_ENV === 'development' ? '/devServer' : restHeartOrigin

export { restHeartClient }
